import { render, staticRenderFns } from "./fl223-notices-list.vue?vue&type=template&id=6a192f60&scoped=true&"
import script from "./fl223-notices-list.vue?vue&type=script&lang=js&"
export * from "./fl223-notices-list.vue?vue&type=script&lang=js&"
import style0 from "./fl223-notices-list.vue?vue&type=style&index=0&id=6a192f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a192f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a192f60')) {
      api.createRecord('6a192f60', component.options)
    } else {
      api.reload('6a192f60', component.options)
    }
    module.hot.accept("./fl223-notices-list.vue?vue&type=template&id=6a192f60&scoped=true&", function () {
      api.rerender('6a192f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl223-notices/fl223-notices-list.vue"
export default component.exports